/**
 =========================================================
 * Material Dashboard 2 React - v2.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2021 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from '@mui/material/CircularProgress';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";


import PageLayout from "examples/LayoutContainers/PageLayout";

import Footer from "examples/Footer";
import Formulario from "./components/Fomulario"
import {useEffect, useState, useContext} from "react";
import {useParams} from "react-router-dom";

import CandidatoContext from "../../context/candidato/candidatoContext";
import axios from '../../config/axios';
import DataTable from "../../examples/Tables/DataTable";
import MDButton from "../../components/MDButton";


const columns = [
    {Header: "Aspectos Avaliados", accessor: "aspecto", width: "25%"},
    {Header: "Pontuação", accessor: "pontuacao", width: "12%"}
];

function Discursiva(props) {
    const [imagems, setImagens] = useState([{nome: '', imagem: ''}])
    const [candidato, setCandidato] = useState([{nome: '', cargo: ''}])
    const [token, setToken] = useState('')
    const {candidatoState, candidatoDispatch} = useContext(CandidatoContext);
    const [rows, setRows] = useState([{aspecto: '', pontuacao: ''}])

    const espelhos = {
        'Administrador':'https://fs.ibfc.org.br/arquivos/2201/IBFC_08_ADMINISTRADOR.pdf',
        'Tecnólogo Em Rede':'https://fs.ibfc.org.br/arquivos/2201/IBFC_13_TECNOLOCO EM REDE.pdf',
        'Farmacêutico':'https://fs.ibfc.org.br/arquivos/2201/IBFC_11_FARMACEUTICO.pdf',
        'Assistente Social':'https://fs.ibfc.org.br/arquivos/2201/IBFC_09_ASSISTENTE_SOCIAL.pdf',
        'Contador':'https://fs.ibfc.org.br/arquivos/2201/IBFC_10_CONTADOR.pdf',
        'Psicólogo':'https://fs.ibfc.org.br/arquivos/2201/IBFC_12_PSICÓLOGO.pdf'
}
    const abre_espelho = ()=>{
        window.location = espelhos[candidato.cargo];
    }

    const monta_tabela_atributos = () => {
        return (
            <MDBox pt={3}>
                <DataTable
                    table={{columns: columns, rows: rows}}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                    canSearch={false}
                />
            </MDBox>
        )
    }

    useEffect(() => {
        //Verifica refresh
        if (candidatoState.concurso.edital.length === 0) {
            candidatoDispatch({type: "REFRESH"})
        }
    }, [])

    useEffect(() => {
        (async () => {
            console.log('candidatoState', candidatoState);
            let response = await axios.get('/candidato/arquivos', {
                params: {
                    token: candidatoState.token
                }
            });
            setImagens(response.data.arquivos);
            setCandidato(response.data.candidato);

            response = await axios.get('/candidato/2201_aspectos', {
                params: {
                    token: candidatoState.token
                }
            });

            console.log('response',response)
            setRows(response.data.aspectos)

        })()
    }, [candidatoState])

    const loading = () => {
        return imagems[0].nome.length === 0 && (<CircularProgress/>);
    }

    return (<PageLayout>
        <MDBox pt={10} width="80%" m="auto">
            <Card>
                <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
                    <Grid container spacing={3} justifyContent='center'>
                        <Grid item xs={12} md={4} xl={2} textAlign="center">
                            <img style={{width: '100%'}}
                                 src={candidatoState.concurso.logo}/>
                        </Grid>
                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="button" fontWeight="bold">
                                {candidatoState.concurso.edital}
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="h4" fontWeight="bold" style={{color: "#184282"}} color="text">
                                FOLHA DISCURSIVA
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="h5" fontWeight="bold" color="text">
                                {candidato.nome}
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} textAlign="center">
                            <MDTypography variant="h6" fontWeight="bold" color="text">
                                {candidato.cargo}
                            </MDTypography>
                        </Grid>


                        <Grid item xs={6} textAlign="center">
                            {monta_tabela_atributos()}
                        </Grid>


                        <Grid item xs={7} textAlign="center">
                        <MDButton variant="gradient" color="info" fullWidth onClick={abre_espelho} >Ver espelho de correção</MDButton>
                        </Grid>

                        <Grid item xs={8} textAlign="center">
                            {imagems[0].nome.length === 0 && (<CircularProgress color="secondary"/>)}
                            <a download={`${candidato.nome}_${candidato.num_cand}_po.jpg`} href={imagems[0].imagem}><img
                                width='100%' src={imagems[0].imagem}/></a>
                        </Grid>
                    </Grid>
                </MDBox>
                {/*<Formulario inscricao={inscricao}/>*/}
            </Card>
            <Footer/>
        </MDBox>
    </PageLayout>);
}

export default Discursiva;
